import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import NumberInput from "components/NumberInput";
import TextInput from "components/TextInput";
import CONFIRM_DELETE from "helpers/confirmDelete";
import "./AgeGroupItem.scss";

function AgeGroupItem({
  deleteItem = () => {},
  rangeStart,
  rangeEnd,
  name,
  updateItem = () => {},
}) {
  const [isHovering, setIsHovering] = useState();
  const [isUpdating, setIsUpdating] = useState();

  return (
    <li
      className="AgeGroupItem list-group-item d-flex justify-content-between"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <span>
        {rangeStart} - {rangeEnd} years old {name && `(${name})`}
      </span>
      {isUpdating && (
        <>
          <Formik
            initialValues={{
              rangeStart,
              rangeEnd,
              name,
            }}
            validationSchema={Yup.object({
              rangeStart: Yup.number().required("Required"),
              rangeEnd: Yup.number().required("Required"),
              name: Yup.string(),
            })}
            onSubmit={async ({ rangeStart, rangeEnd, name }) => {
              updateItem({
                rangeStart,
                rangeEnd,
                name,
              });
              setIsUpdating(false);
            }}
          >
            <Form className="needs-validation" noValidate>
              <div className="row">
                <NumberInput
                  label="Min"
                  name="rangeStart"
                  min="0"
                  step="1"
                  size="col-sm-12 col-md-6 col-lg-4"
                />
                <NumberInput
                  label="Max"
                  name="rangeEnd"
                  min="1"
                  step="1"
                  size="col-sm-12 col-md-6 col-lg-4"
                />
                <TextInput label="Name" name="name" />
              </div>
              <button type="submit" className="btn btn-success mr-1">
                Submit
              </button>
              <button
                className="btn btn-danger"
                onClick={(e) => {
                  e.preventDefault();
                  setIsUpdating(false);
                }}
              >
                Cancel
              </button>
            </Form>
          </Formik>
        </>
      )}
      {isHovering && !isUpdating && (
        <div>
          <button
            className="btn btn-warning mr-1"
            onClick={() => setIsUpdating(true)}
          >
            Update
          </button>
          <button
            className="btn btn-danger"
            onClick={() =>
              CONFIRM_DELETE(() => {
                deleteItem();
              })
            }
          >
            Delete
          </button>
        </div>
      )}
    </li>
  );
}

export default AgeGroupItem;
